import { em } from 'polished'
import styled from 'styled-components'

import ButtonAsyncActionSt from 'components/ButtonAsyncActionSt'
import { CartText } from 'styles/components/typography'

export const Wrapper = styled.div`
  margin-top: ${em(35)};
  margin-bottom: ${em(35)};
  max-width: ${em(463)};
  text-align: center;
  margin-left: auto;
  margin-right: auto;

  ${p => p.theme.mq.upMd} {
    margin-top: ${em(63)};
    margin-bottom: 0;
  }
`

export const StripeBlock = styled.div`
  display: block;
  position: relative;
  width: ${em(51)};
  height: ${em(22)};
  margin: ${em(11)} auto 0;

  ${p => p.theme.mq.upMd} {
    display: inline-block;
    top: ${em(4)};
    width: ${em(38)};
    height: ${em(16.5)};
    margin: 0;
  }
`

export const Ordering = styled.div`
  display: flex;
  flex-direction: column-reverse;

  ${p => p.theme.mq.upMd} {
    flex-direction: column;
  }
`

export const ButtonBox = styled.div`
  display: flex;
  justify-content: center;

  & .btn--payment {
    width: 100%;
  }

  ${p => p.theme.mq.upMd} {
    display: block;
    width: 50%;
    max-width: ${em(250)};
  }
`

export const IconBox = styled.div`
  text-align: center;
  padding-bottom: ${em(20)};
`

export const Indent = styled.div`
  padding-bottom: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding-bottom: 0;
    padding-left: ${em(10)};
    padding-right: ${em(10)};
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  margin-top: ${em(40)};

  ${p => p.theme.mq.upMd} {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: ${em(33)};
    margin-bottom: ${em(30)};
  }
`

export const ButtonContent = styled.div`
  padding: 0 ${em(35)};
`

export const CartTextStyled = styled(CartText)`
  display: block;
  font-size: ${p => p.theme.typography.textSmallDescr};
  line-height: ${p => p.theme.typography.textSmallDescrLh};

  ${p => p.theme.mq.upMd} {
    display: inline;
    font-size: ${p => p.theme.typography.cartFontSize};
    line-height: ${p => p.theme.typography.cartFontLh};
  }
`

export const ButtonAsyncActionStStyled = styled(ButtonAsyncActionSt)`
  width: 100%;
`
